export const STANDARD_FRAMING_FORMATS = [
  { code: "std_30x30", frame_label: "30×30", frame_width_cm: 30, frame_height_cm: 30, print_label: "21×21", print_width_cm: 21, print_height_cm: 21, costs: { milo_white: 6.99, milo_black: 9.99, panel_float: 9.99 } },
  { code: "std_30x40", frame_label: "30×40", frame_width_cm: 30, frame_height_cm: 40, print_label: "A4 · 21×29,7", print_width_cm: 21, print_height_cm: 29.7, costs: { milo_white: 9.99, milo_black: 9.99, panel_float: 9.99 } },
  { code: "std_40x40", frame_label: "40×40", frame_width_cm: 40, frame_height_cm: 40, print_label: "30×30", print_width_cm: 30, print_height_cm: 30, costs: { milo_white: 15.99, milo_black: 15.99, panel_float: 15.99 } },
  { code: "std_40x50", frame_label: "40×50", frame_width_cm: 40, frame_height_cm: 50, print_label: "30×40", print_width_cm: 30, print_height_cm: 40, costs: { milo_white: 12.99, milo_black: 12.99, panel_float: 12.99 } },
  { code: "std_50x70", frame_label: "50×70", frame_width_cm: 50, frame_height_cm: 70, print_label: "40×50", print_width_cm: 40, print_height_cm: 50, costs: { milo_white: 19.99, milo_black: 19.99, panel_float: 19.99 } },
  { code: "std_60x80", frame_label: "60×80", frame_width_cm: 60, frame_height_cm: 80, print_label: "40×60", print_width_cm: 40, print_height_cm: 60, costs: { milo_white: 22.99, milo_black: 22.99, panel_float: 22.99 } },
  { code: "std_70x100", frame_label: "70×100", frame_width_cm: 70, frame_height_cm: 100, print_label: "50×70", print_width_cm: 50, print_height_cm: 70, costs: { milo_white: 29.99, milo_black: 29.99, panel_float: 29.99 } },
];

export const FRAMING_FINISHES = [
  { code: "milo_black", label: "Milo negro", short: "Negro" },
  { code: "milo_white", label: "Milo blanco", short: "Blanco" },
  { code: "panel_float", label: "Panel rígido volado", short: "Panel" },
];

export const dpiForCrop = (widthPx, heightPx, printW, printH) => {
  if (!widthPx || !heightPx || !printW || !printH) return 0;
  return Math.floor(Math.min(widthPx / (printW / 2.54), heightPx / (printH / 2.54)));
};

export const buildStandardFramingOptions = (widthPx, heightPx, existing = []) => {
  const existingByCode = Object.fromEntries((existing || []).map((o) => [o.code, o]));
  const netDefaults = { std_30x30: 35, std_30x40: 45, std_40x40: 60, std_40x50: 85, std_50x70: 130, std_60x80: 180, std_70x100: 240 };
  return STANDARD_FRAMING_FORMATS.map((f) => {
    const prev = existingByCode[f.code] || {};
    const dpi = dpiForCrop(widthPx, heightPx, f.print_width_cm, f.print_height_cm);
    return {
      ...f,
      enabled: prev.enabled ?? (dpi >= 200),
      quality_ok: dpi >= 200,
      dpi,
      net_earnings: prev.net_earnings ?? netDefaults[f.code] ?? 80,
      crop_x: prev.crop_x ?? 0.5,
      crop_y: prev.crop_y ?? 0.5,
    };
  });
};

export const framingRetail = (option, finishCode, settings) => {
  const printCost = Math.max(settings.print_min, settings.print_rate_per_m2 * (option.print_width_cm / 100) * (option.print_height_cm / 100));
  const finishCost = option.costs?.[finishCode] ?? 0;
  const margin = 1 - settings.gallery_pct - settings.referrer_pct;
  return margin > 0 ? (Number(option.net_earnings || 0) + printCost + finishCost) / margin : 0;
};
